/** @import modules */

import { createContext } from "react";

/** @export context */

export const PagenameContext = createContext ( null );